import $ from 'jquery';
import cookie from 'react-cookies';
import * as globalUtils from '../../Global/global_js';
import * as playerDesignUtils from '../js/playerPageDesignSettings';
import * as ticketsUtils from '../js/video_tickets';
import * as Index2Utils from '../js/index2';
import * as DownloadVideoUtils from '../js/video_download_payment';
var video_guid = "";
var video_type = "";
var dv_account_guid = "";
var video_owner_account_guid = "";
var visitor_guid = "";
var visitor_ip = "";
var browser = "";
var error_info = localStorage.getItem("error_info");
var video_info = "";
var stream_type_id = "";
var video_expired_date = "";
var video_location = "";
var is_owner = false;
var video_old_password = "";
var password_flag = "false";
var password_type = "";
var video_token = "";
// array with monthes name
var m_names = new Array("January", "February", "March",
    "April", "May", "June", "July", "August", "September",
    "October", "November", "December");
var token_flag = "";
var valid_token = "false";
var visitor_token;
var video_owner_email = "";
var player_pay_per_view = false;
var player_pay_per_view_payment_id = "";
var ticket_used = "false";
var interval = null;
var current_playing_interval = null;
var compare_date = 1990;
var embed_text = "";
var yt_id = "";
var vortex_url = "";
var is_youtube = false;
var special_parameters = null;
var channel_guid = "";
var check_video_channel_validation = null;
var first_time_play_video = true;
var check_ticket_expire_time = null;
var my_arguments;
var download_video_transaction;
var buy_download_video_email;
export function documnetReady(t)
{

    error_info = "account_guid=" + t.state.videoData.userGuid;
    video_guid = t.state.videoData.videoGuid;
    video_type = t.state.videoData.videoType;
    dv_account_guid = t.state.videoData.userGuid;
    channel_guid = t.state.videoData.channelGuid;
    visitor_guid = globalUtils.createGuid(20);
    video_token = t.state.videoData.video_token;
    browser = Index2Utils.get_browser_name();
    download_video_transaction = globalUtils.getParameterByName("dvt", t);
    buy_download_video_email = globalUtils.getParameterByName("em", t);

    $.ajax({
        type: "GET",
        url: "https://demo1.devosvideo.com/getip",
        async: true,
        dataType: "text",
        success: function (response)
        {
            visitor_ip = response
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    visitor_ip: visitor_ip,
                }
            }), () =>
            {
                insert_visitor_info(t);
                insert_visitor_info_to_dic(visitor_ip);
            });

        },
        error: function (response)
        { },
    });

    console.log("browser=", browser);

    //// check if video opened from channel page
    if (channel_guid != "")
    {
        get_channel_with_setting(t);
        check_video_channel_validation = window.setInterval(function ()
        {
            get_channel_with_setting(t);
        }, 120000);
    }
    else
    {
        load_video_info(t);
    }

    t.toggleBlocking(false);
}
function insert_visitor_info_to_dic(t)
{
    var more_error_info = "vod_guid=" + video_guid;
    try
    {
        

        var api_link = localStorage.getItem("api_url") + "insert_visitor_info_by_visitor_guid_in_dictionary";
        var parameters = {
            visitor_guid: visitor_guid,
            account_guid: dv_account_guid,
            video_guid: video_guid,
            video_type: video_type,
            visitor_ip: visitor_ip,
            browser: browser,
            visitor_os: navigator.platform,
            vistor_agent: navigator.userAgent.toLowerCase(),
            media_owner_account_guid: video_owner_account_guid,
        };
        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: true,
            dataType: "json",
            success: insert_visitor_info_to_dic_success,
            error: insert_visitor_info_to_dic_error
        });
    }
    catch (ex)
    {
        //globalUtils.send_error_fun("playerUiJs_index.js",
        //    "insert_visitor_info",
        //    ex, error_info + "&video_guid=" + video_guid);
    }
}
function insert_visitor_info_to_dic_success(response)
{
    
    if (response)
    {
        visitor_guid = response;
        setInterval(() => { update_visitor_info_to_dic() },60000)
    }
}
function insert_visitor_info_to_dic_error(ex)
{
    
}

function update_visitor_info_to_dic(t)
{
    
    var more_error_info = "vod_guid=" + video_guid;
    try
    {

        var api_link = localStorage.getItem("api_url") + "update_visitor_info_by_visitor_guid_in_dictionary";
        var parameters = {
            visitor_guid: visitor_guid,
            media_owner_account_guid: video_owner_account_guid,
        };
        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: true,
            dataType: "json",
            success: update_visitor_info_to_dic_success,
            error: update_visitor_info_to_dic_error
        });
    }
    catch (ex)
    {
        
        //globalUtils.send_error_fun("playerUiJs_index.js",
        //    "insert_visitor_info",
        //    ex, error_info + "&video_guid=" + video_guid);
    }
}
function update_visitor_info_to_dic_success()
{
    
}
function update_visitor_info_to_dic_error(ex)
{
    
}
function keyboardShourcutForPlayer(t, e)
{
    try
    {

        if (e.keyCode === 32)
        {
            e.preventDefault();
            if (t.PlayerItem !== undefined)
            {
                t.PlayerItem.onPauseButtonClick();
                //vortex.vortexplayer('pause');
            }
            if (t.PlayerItem !== undefined)
            {
                t.PlayerItem.onPlayButtonClick();
                //vortex.vortexplayer('play');
            }
        }
        //up
        else if (e.keyCode === 38)
        {
            try
            {
                e.preventDefault();
                t.PlayerItem.onUpArrowClicked();
            }
            catch (ex)
            {

                var x = ex;
            }
        }
        //down
        else if (e.keyCode === 40)
        {
            try
            {
                e.preventDefault();
                t.PlayerItem.onDownArrowClicked();

            }
            catch (ex)
            {

                var x = ex;
            }
        }
        //left
        else if (e.keyCode === 37)
        {
            try
            {
                e.preventDefault();
                t.PlayerItem.onLeftArrowClicked();
            }
            catch (ex)
            {
                ;
                var x = ex;
            }
        }
        //right
        else if (e.keyCode === 39)
        {
            try
            {
                e.preventDefault();
                t.PlayerItem.onRightArrowClicked();
            }
            catch (ex)
            {

                var x = ex;
                console.log("ex= ", ex)
            }
        }
        // mute
        else if (e.keyCode === 77)
        {
            try
            {
                e.preventDefault();
                t.PlayerItem.onMuteClicked();

            }
            catch (ex)
            {

                var x = ex;
                console.log("ex= ", ex)
            }
        }
        // full screen
        else if (e.keyCode === 70)
        {
            try
            {
                document.activeElement.tabIndex = 1;
                t.PlayerItem.onFullScreenClicked();

            }
            catch (ex)
            {

                var x = ex;
                console.log("ex= ", ex)
            }
        }
        // caption and loop playlist
        else if (e.keyCode === 67)
        {
            e.preventDefault();
            t.PlayerItem.onCLetterClicked();
        }
        // seet to 0% of video 
        else if (e.keyCode === 48 || e.keyCode === 96)
        {
            try
            {
                e.preventDefault();
                t.PlayerItem.onOffessetChange(0);
            }
            catch (ex)
            {

                var x = ex;
            }
        }
        // seet to % of video 
        else if (e.keyCode === 49 || e.keyCode === 50 || e.keyCode === 51 || e.keyCode === 52 || e.keyCode === 53
            || e.keyCode === 54 || e.keyCode === 55 || e.keyCode === 56 || e.keyCode === 57 ||
            e.keyCode === 97 || e.keyCode === 98 || e.keyCode === 99 || e.keyCode === 100
            || e.keyCode === 101 || e.keyCode === 102 || e.keyCode === 103 || e.keyCode === 104 ||
            e.keyCode === 105)
        {


            e.preventDefault();
            t.PlayerItem.onSeekByKeyCodeClicked(e.keyCode);

        }
    }
    catch (ex)
    {

    }

}
// load video
export function load_video_info(t)
{
    try
    {
        if (video_guid != "" && video_type != "")
        {
            t.setState({ blocking: true }, () =>
            {
                var api_link = localStorage.getItem("api_url") + "react_get_video_info_and_player_design_info";
                var parameters = {
                    video_guid: video_guid,
                    video_type: video_type,
                    account_guid: dv_account_guid,
                    error_info: "account_guid=" + t.state.videoData.userGuid + "&video_guid=" + video_guid,
                    visitor_ip: visitor_ip
                };

                $.ajax({
                    type: "POST",
                    url: api_link,
                    data: parameters,
                    async: true,
                    dataType: "json",
                    success: function (response)
                    { load_video_info_success(t, response) },
                    error: function (ex)
                    {
                        load_video_info_error(t, ex)
                    }
                });
            })
        }
        else
        {
            window.location = "home";
        }
    }
    catch (ex)
    {
        t.setState({ blocking2: false, errorLoading: true })
        globalUtils.send_error_fun("playerUiJs_index.js",
            "load_video_info",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

function load_video_info_success(t, response)
{
    try
    {
        if (response != null)
        {
            video_info = response;
            //if the re-routing is true redirect to Url
            if (video_info.is_routing === "true")
            {
                window.location.href = video_info.routing_url;
            }

            video_owner_account_guid = response.account_guid;
            var isHLS = false;
            if (video_owner_account_guid === "c3363612")
            {
                isHLS = true;
            }

            t.setState(prevState => ({
                isHLSPlayer: isHLS,
                videoData: {
                    ...prevState.videoData,
                    video_owner_account_guid: video_owner_account_guid,
                    video_owner_name: response.video_owner_firstname + " " + response.video_owner_lastname,
                    creator_id: response.creator_id,
                    check_free_download: response.check_free_download
                }
            }), () =>
            {
                console.log("response.creator_id = ", response.creator_id)
                Index2Utils.get_pre_roll_info(t);
            });
            stream_type_id = response.stream_type_id;
            yt_id = response.stream_id
            if (video_owner_account_guid === t.state.videoData.userGuid)
            {
                is_owner = true;
                var url = window.location.protocol + '//' + window.location.hostname;
                if (url.indexOf("localhost") > -1)
                {
                    url = url + ":" + window.location.port;
                }
                if (video_type == "1")
                {
                    embed_text = "<iframe width=\"630\" height=\"400\" src=\"" + url + "/Embed?vg=" + video_guid + "&vt=" + video_type + "&ag=" + video_info.account_guid + '&fn=' + video_info.video_filename + "\" style='border:0;' allowfullscreen webkitallowfullscreen='true' mozallowfullscreen='true'></iframe>";
                }
                else
                {
                    embed_text = "<iframe width=\"630\" height=\"400\" src=\"" + url + "/Embed?vg=" + video_guid + "&ag=" + video_info.account_guid + "&sn=" + video_info.streamName + "&an=" + video_info.application_password + "&st=" + stream_type_id + "&yt_id=" + yt_id + "&vt=" + video_type + "\" style='border:0;' allowfullscreen webkitallowfullscreen='true' mozallowfullscreen='true'></iframe>";
                }
            }

            var video_title = $.parseHTML(response.video_title)[0].nodeValue;
            video_title = formate_video_title_date(video_title);
            document.title = video_title;


            var date_now = new Date();
            // if chrome
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && response.video_expire_datetime.indexOf('T') > -1)
            {
                response.video_expire_datetime = response.video_expire_datetime.replace('T', ' ');
            }
            if (response.video_expire_datetime.split('-')[0] != '1990' && video_type == "1")
            {
                video_expired_date = response.video_expire_datetime;
                video_expired_date = new Date(video_expired_date);
                var time_country_zone = -(video_expired_date.getTimezoneOffset() / 60);
                compare_date = compare(video_expired_date, date_now);
            }

            // check if account is not valid
            if (compare_date == -1 && dv_account_guid != response.account_guid && response.stream_type_id == 0)
            {
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        video_owner_account_guid: video_owner_account_guid,
                        video_owner_account_valid: response.account_valid,
                        video_owner_email_address: response.video_owner_email,
                        video_owner_account_id: response.account_id,
                        video_title: video_title,
                        error_message: "This video is expired",
                    }
                }));
            }
            else if (response.account_valid != 1)
            {
                if (response.donation == "true"
                    && response.account_valid != 2
                    && response.account_valid != 3
                    && response.account_valid != 6
                    && response.account_valid != 7
                    && response.account_valid != 10
                    && response.account_valid != 11
                    && dv_account_guid != response.account_guid)
                {
                    //        var donation_type = "";
                    //        if (response.account_Storage_used > response.account_Storage && response.account_bandwidth_used > response.account_bandwidth)
                    //        {
                    //            donation_type = "bandwidth&storage";
                    //        }
                    //        else if (response.account_bandwidth_used > response.account_bandwidth)
                    //        {
                    //            donation_type = "bandwidth";
                    //        }
                    //        else if (response.account_Storage_used > response.account_Storage)
                    //        {
                    //            donation_type = "storage";
                    //        }
                    //        //// here we clear check account vaild interval  
                    //        //clearInterval(check_account_vaild_interval);
                    //        t.setState(prevState => ({
                    //            videoData: {
                    //                ...prevState.videoData,
                    //                video_owner_account_guid: video_owner_account_guid,
                    //                video_owner_account_valid: response.account_valid,
                    //                video_owner_email_address: response.video_owner_email,
                    //                video_owner_account_id: response.account_id,
                    //                video_title: video_title,
                    //                error_message: "",
                    //                donation_type: donation_type,
                    //                allow_donation_and_account_not_valid: true,
                    //                show_donation_popup: true,
                    //            }
                    //        }));
                }
                else
                {
                    t.setState(prevState => ({
                        videoData: {
                            ...prevState.videoData,
                            video_owner_account_guid: video_owner_account_guid,
                            video_owner_account_valid: response.account_valid,
                            video_owner_email_address: response.video_owner_email,
                            video_owner_account_id: response.account_id,
                            video_title: video_title,
                            error_message: "Invalid video",
                        }
                    }));
                    // here we clear check account vaild interval  
                    clearInterval(interval);
                }
            }
            else
            {
                var donation = false;
                var donation_type = 0;
                var vod_donation_paypal_id = 0;
                if (response.donation == "true" || response.vod_paypal_donation === "true")
                {
                    donation = true;
                    donation_type = response.donation_type
                    vod_donation_paypal_id = response.vod_donation_paypal_id
                }
                //else
                //{
                //    $("#donation_1").hide();
                //}
                //if (response.vod_paypal_donation == "true")
                //{
                //    $("#paypal_donation").show();
                //    $("#vod_donation_paypal_id").val(response.vod_donation_paypal_id);
                //}
                //else
                //{
                //    $("#paypal_donation").hide();
                //}
                
                check_video_password(t, response, visitor_token, ticket_used, valid_token);
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        video_owner_account_guid: video_owner_account_guid,
                        video_owner_account_valid: response.account_valid,
                        video_owner_email_address: response.video_owner_email,
                        video_owner_account_id: response.account_id,
                        video_title: video_title,
                        video_desc: response.video_desc,
                        error_message: "",
                        is_owner: is_owner,
                        embed_text: embed_text,
                        player_pay_per_view: response.player_pay_per_view,
                        donation: donation,
                        donation_type: donation_type,
                        vod_donation_paypal_id: vod_donation_paypal_id,
                        paypalButtonCode: response.paypal_button_code,
                        paypalButtonCodeTitle: response.paypal_button_title,
                        use_account_payment_for_download_videos: response.use_account_payment_for_download_videos,
                        payment_id_for_download_videos: response.payment_id_for_download_videos,
                        download_payment_type: response.download_payment_type,
                        
                        download_video_transaction: download_video_transaction,
                        buy_download_video_email: buy_download_video_email
                    },
                    video_info: video_info,
                    downloadVideoPrice: response.downloadvideo_price,
                }), () =>
                {
                    if (response.paypal_button_code && document.getElementById("paypal_button_div"))
                    {
                        document.getElementById("paypal_button_div").innerHTML = response.paypal_button_code;
                    }
                    var is_linearBroadcastLive = globalUtils.getParameterByName("pn", t) === "lnb" ? true : false;
                    if (is_linearBroadcastLive)
                    {
                        get_linearbroadcast_current_event_playing(t, globalUtils.getParameterByName("ottacg", t));
                    }
                });
            }

        }
        else
        {
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    error_message: "This video is deleted",
                }
            }));

            //clearInterval(check_video_expiration);
            //clearInterval(check_ticket_expire_time);
            //// here we clear check account vaild interval  
            //clearInterval(check_account_vaild_interval);
        }
        const download_video_transaction = globalUtils.getParameterByName("dvt", t);
        
        if (download_video_transaction && download_video_transaction != "error")
        {
            DownloadVideoUtils.insert_new_video_download_payment(t, download_video_transaction);
        }
    }
    catch (ex)
    {
        t.setState({ blocking2: false, errorLoading: true })
        globalUtils.send_error_fun("playerUiJs_index.js",
            "load_video_info_success",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

function load_video_info_error(t, ex)
{
    t.setState({ blocking2: false, errorLoading: true })
    globalUtils.send_error_fun("playerUiJs_index.js",
        "load_video_info_error",
        ex, "account_guid=" + t.state.videoData.userGuid + "&video_guid=" + video_guid);
}
function insert_visitor_info(t)
{
    var more_error_info = "account_guid=" + dv_account_guid + "&video_guid=" + video_guid;
    try
    {

        var api_link = localStorage.getItem("api_url") + "insert_or_update_visitor_info_by_visitor_guid";
        var parameters = {
            visitor_guid: visitor_guid,
            account_guid: dv_account_guid,
            video_guid: video_guid,
            video_type: video_type,
            visitor_ip: visitor_ip,
            browser: browser,
            visitor_os: navigator.platform,
            vistor_agent: navigator.userAgent.toLowerCase(),
            media_owner_account_guid: video_owner_account_guid,
            error_info: more_error_info
        };
        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: true,
            dataType: "json",
            success: insert_visitor_info_success,
            error: insert_visitor_info_error
        });
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "insert_visitor_info",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}
function insert_visitor_info_success(response)
{
    if (response)
    {

    }
}
function insert_visitor_info_error(ex)
{
    globalUtils.send_error_fun("playerUiJs_index.js",
        "insert_visitor_info_error",
        ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
}
function formate_video_title_date(video_title)
{
    try
    {
        var _title = video_title

        // check if video title has date time (comes from recorded streams) to convert this time  to utc time
        var split_title = _title.split('_');
        var date = Date.parse(split_title[1]);
        if (!isNaN(date))
        {
            date = new Date(date);

            var video_date_time = new Date(date);
            var time_country_zone = -(video_date_time.getTimezoneOffset() / 60);
            var hours_plus_time_country_zone = (video_date_time).setHours((video_date_time).getHours() + time_country_zone);

            // vod creation date time
            var Creation_Date = new Array();
            Creation_Date = globalUtils.get_proper_date(hours_plus_time_country_zone);
            _title = split_title[0] + " " + Creation_Date[0] + " " + m_names[Creation_Date[1]] + " " + Creation_Date[2] + " " + Creation_Date[3] + ":" + Creation_Date[4] + ":" + Creation_Date[5];


        }
        return _title;
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "formate_video_title_date",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
        return "";
    }
}
function compare(start_date, end_date)
{
    try
    {
        return (
            isFinite(start_date = m_convert(start_date).valueOf()) &&
                isFinite(end_date = m_convert(end_date).valueOf()) ?
                (start_date > end_date) - (start_date < end_date) :
                NaN
        );
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "compare",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}
function m_convert(date)
{
    try
    {
        return (
            date.constructor === Date ? date :
                date.constructor === Array ? new Date(date[0], date[1], date[2]) :
                    date.constructor === Number ? new Date(date) :
                        date.constructor === String ? new Date(date) :
                            typeof date === "object" ? new Date(date.year, date.month, date.date) :
                                NaN
        );
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "m_convert",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

export function check_video_password(t, response, visitor_token, ticket_used, valid_token)
{
    try
    {
        video_old_password = response.video_password;
        // check if there is cookie for tickets on this video
        token_flag = globalUtils.getCookie(video_guid);
        if (token_flag == null && dv_account_guid != response.account_guid)
        {
            token_flag = 'false';
        }

        // check if there is pay per view 
        if (valid_token == "false" && response.player_pay_per_view != null && dv_account_guid != response.account_guid)
        {
            player_pay_per_view = true;
            player_pay_per_view_payment_id = response.player_pay_per_view_payment_id;
        }
        // check for video password
        if (ticket_used == "false" && response.video_require_password != "false" && dv_account_guid != response.account_guid)
        {
            // check if there is video password in cookie load video info , if not exists show password popup 
            var video_pass = get_video_pass_from_cookie();

            if (video_pass != "") 
            {
                if (response.video_password == video_pass)
                {
                    password_type = "from_cookie_password";
                    test_password_success(t, "true", video_info);
                }
                else
                {
                    password_flag = "true";
                    t.setState(prevState => ({
                        password: password_flag,
                        isPasswordCorrect: false,

                    }));
                }
            }
            else
            {
                password_flag = "true";
                t.setState(prevState => ({
                    password: password_flag,
                    isPasswordCorrect: false,
                }));
            }
        }
        else if (player_pay_per_view && token_flag == 'false')
        {

            visitor_token = "";
            valid_token = "false";
            t.setState({ showTicketPopup: true, }, () => { ticketsUtils.load_tickets(t) })

            video_owner_email = response.video_owner_email;
            if (video_token != null && video_token != "" && password_flag == "false")
            {
                ticketsUtils.apply_token(t, video_info);
            }

        }
        else
        {
            // if video has no password load video
            t.setState(prevState => ({
                password: "false",
                isPasswordCorrect: true,
            }), () =>
            {
                load_video_after_password_check(t, response);
            });

        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "check_video_password",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}
function load_video_after_password_check(t, response)
{
    try
    {

        interval = setInterval(function ()
        {
            check_video_info_changed(t);
        }, 120000);

        if (stream_type_id === 8)
        {
            vortex_url = response.external_live_link.split('?')[0];
            special_parameters = response.external_live_link.split('?')[1];
        }
        else if (stream_type_id === 5)
        {
            is_youtube = true;
            vortex_url = response.external_live_link.split('?')[0];
            special_parameters = response.external_live_link.split('?')[1];
        }
        else if (response.vod_is_youtube === "True")
        {
            is_youtube = true;
            vortex_url = response.vod_youtubet_url;
        }
        else if (stream_type_id === 9)
        {
            is_youtube = true;
            vortex_url = response.external_live_link;
        }
        else if (stream_type_id === 1)
        {
            vortex_url = localStorage.getItem("get_stream_link") + response.streamName + response.application_password + "/" + response.streamName + response.application_password + ".m3u8";
        }
        else 
        {
            vortex_url = localStorage.getItem("get_player_link") + 'player_handler.ashx?vt=1&ag=' + video_info.account_guid + '&fn=' + video_info.video_filename + "&ci=" + video_info.creator_id;
            //is_youtube = true;
            //vortex_url = "https://www.youtube.com/watch?v=X7R-q9rsrtU";
            //vortex_url = "https://api.helnix.com/streamsie_api/player_handler.ashx?vt=1&ag=0766a1ee&fn=320bcf8552.mp4&ci=0";
        }

        // load data for admin settings section page and div
        playerDesignUtils.load_design(t, response);

        if (token_flag != 'false' && token_flag != null && dv_account_guid != response.account_guid)
        {
            ticketsUtils.check_ticket_expire_time(t);
            setInterval(function () { ticketsUtils.check_ticket_expire_time(t); }, 60000);
        }
        var VttGuid = response.video_vtt;
        var CaptionSrc = "";
        if (VttGuid !== "")
        {
            CaptionSrc = localStorage.getItem("get_image_server_url") + "accounts_media/vtt/" + video_owner_account_guid + "/" + VttGuid;
        }
        var download_url = vortex_url;
        download_url = download_url.replace("player_handler", "download_handler");

        t.setState(prevState => ({

            videoData: {
                ...prevState.videoData,
                video_url: vortex_url,
                //video_url: "https://www.rmp-streaming.com/media/big-buck-bunny-360p.mp4",
                special_parameters: special_parameters,
                isYoutube: is_youtube,
                video_vtt: CaptionSrc,
                download_url: download_url
                //video_vtt: "http://account.helnix.me/accounts_media/vtt/56aee144/0ad033fc89.vtt"

            },
        }))
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "load_video_after_password_check",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }

}

function check_video_info_changed(t)
{
    if (video_guid != "" && video_type != "")
    {
        var api_link = localStorage.getItem("api_url") + "react_get_video_info_and_player_design_info";
        var parameters = {
            video_guid: video_guid,
            video_type: video_type,
            account_guid: dv_account_guid,
            error_info: "account_guid=" + dv_account_guid + "&video_guid=" + video_guid,
            visitor_ip: visitor_ip
        };

        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: true,
            dataType: "json",
            success: function (response)
            { check_video_info_changed_success(t, response) },
            error: function () { console.log("error"); }
        });
    }
    else
    {
        window.location = "home";
    }
}
function check_video_info_changed_success(t, response)
{
    // get all video info 
    if (response !== null)
    {
        var old_info = {
            video_title: video_info.video_title,
            video_desc: video_info.video_desc,
            video_password: video_info.video_password,
            video_private: video_info.video_private,
            video_owner_account_valid: video_info.account_valid,
            is_owner: is_owner,
            comapre_date: compare_date,
            //player_pay_per_view: player_pay_per_view.player_pay_per_view
        }

        var new_is_owner = false;
        if (response.account_guid === t.state.videoData.userGuid)
        {
            new_is_owner = true;
        }
        var new_compare_date = 1990;
        var date_now = new Date();
        // if chrome
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && response.video_expire_datetime.indexOf('T') > -1)
        {
            response.video_expire_datetime = response.video_expire_datetime.replace('T', ' ');
        }
        if (response.video_expire_datetime.split('-')[0] != '1990' && video_type == "1")
        {
            video_expired_date = response.video_expire_datetime;
            video_expired_date = new Date(video_expired_date);
            new_compare_date = compare(video_expired_date, date_now);
        }
        var new_video_info = {
            video_title: response.video_title,
            video_desc: response.video_desc,
            video_password: response.video_password,
            video_private: response.video_private,
            video_owner_account_valid: response.account_valid,
            is_owner: new_is_owner,
            comapre_date: new_compare_date,
            //player_pay_per_view: response.player_pay_per_view
        }
        var result = (JSON.stringify(new_video_info) === JSON.stringify(old_info));
        if (result === false)
        {
            load_video_info_success(t, response);
        }
    }
    else
    {
        window.location.reload();
    }
}
// access video by its password
export function video_password_click(t, password)
{
    try
    {
        // if it is from password popup
        if (password == "")
        {
            password = $('#video_password').val().trim();
        }
        // if password comes not empty
        if (password != "")
        {
            var api_link = localStorage.getItem("api_url") + "check_video_password";
            var parameters = {
                video_guid: video_guid,
                video_type: video_type,
                video_password: password,
                account_guid: dv_account_guid,
                error_info: "account_guid=" + dv_account_guid + "&video_guid=" + video_guid
            };

            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response) { test_password_success(t, response, t.state.video_info) },
                error: test_password_error

            });
        }
        else
        {
            // error password
            t.showToast("Please enter video password.", "error")
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "video_password_click",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }

}

// test if true password complete loading video
function test_password_success(t, response, video_info)
{
    try
    {
        // if password is true
        if (response == "true")
        {
            t.setState(prevState => ({
                password: "false",
                isPasswordCorrect: true,
            }));
            // ensure user is login
            //if (password_type !== "from_cookie_password")
            if (dv_account_guid != "" && dv_account_guid != null)
            {
                // save video password to vp cookie
                set_video_password_cookie(t.state.videoPassword);
            }


            if (player_pay_per_view)
            {
                token_flag = globalUtils.getCookie(video_guid);
                if (token_flag == null)
                {
                    token_flag = 'false';
                }
                if (video_token != null && video_token != "" && token_flag == 'false')
                {
                    //$('#token_text').val(video_token);
                    ticketsUtils.apply_token(t, video_info);
                }
                // by youstina maher for react project 17-12-2020
                else if (video_token != null && video_token != "" && token_flag !== 'false')
                {
                    ticketsUtils.check_ticket_expire_time(t);
                    check_ticket_expire_time = setInterval(function () { ticketsUtils.check_ticket_expire_time(t); }, 60000);
                }
                else
                {
                    visitor_token = "";
                    valid_token = "false";
                    t.setState({ showTicketPopup: true, }, () => { ticketsUtils.load_tickets(t) })
                }
            }
            else
            {

                //complete page loading
                load_video_after_password_check(t, video_info);
            }
        }
        else
        {
            t.setState(prevState => ({
                password: "true",
                isPasswordCorrect: false,
                blocking: false,
            }), () => { t.showToast("Please enter a valid password.", "error"); });



        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "test_password_success",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

// add video password to existing passwords cookie or create anew cookie
function set_video_password_cookie(video_password)
{
    try
    {
        // read all passwords cookie
        var old_cookie = globalUtils.getCookie("vp");

        // if found and not comming password not empty
        if (old_cookie != null && video_password != "")
        {
            // append new video password to cookie
            document.cookie = "vp" + "=" + old_cookie + "&" + video_guid + "_" + video_password;
        }
        // if cookie found and video password not empty
        else if (old_cookie == null)
        {
            // create cookie to save password
            document.cookie = "vp" + "=" + video_guid + "_" + video_password;
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "set_video_password_cookie",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

function test_password_error(ex)
{
    globalUtils.send_error_fun("playerUiJs_index.js",
        "test_password_error",
        ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
}

/////////////////////////////////////////// end video password check

function get_video_pass_from_cookie()
{
    try
    {
        var video_password = "";
        var old_cookie = globalUtils.getCookie("vp");
        // if cookie exist
        if (old_cookie != null)
        {
            if (old_cookie.indexOf('&') > -1)
            {
                var videos_guids = old_cookie.split('&');
                // find password of current video
                for (var i = 0; i < videos_guids.length; i++)
                {
                    var guid = videos_guids[i].split('_');
                    if (guid[0] == video_guid)
                    {
                        video_password = guid[1];
                    }
                }
            }
            else
            {
                var guid = old_cookie.split('_');
                if (guid[0] == video_guid)
                {
                    video_password = guid[1];
                }
            }
        }
        return video_password;
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "get_video_pass_from_cookie",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
        return "";
    }
}
export function copyToClipboard(value)
{
    try
    {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(value).select();
        document.execCommand("copy");
        $temp.remove();
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "copyToClipboard",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

function get_channel_with_setting(t)
{
    var more_error_info = "account_guid=" + dv_account_guid + "&video_guid=" + video_guid + "api_link=" + localStorage.getItem("api_url") + "get_channel_with_settings_by_channel_guid";
    try
    {
        if (localStorage.getItem("api_url"))
        {

            var api_link = localStorage.getItem("api_url") + "get_channel_with_settings_by_channel_guid";
            var parameters = {
                channel_guid: channel_guid,
                search_val: '',
                filter_by_cat: '',
                account_guid: dv_account_guid,
                error_info: more_error_info
            };
            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                { get_channel_with_setting_success(t, response); },
                error: get_channel_with_setting_error
            });
        }
        else
        {

            globalUtils.get_api_url(t);
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "get_channel_with_setting",
            ex, "account_guid=" + dv_account_guid + "&channel_guid=" + channel_guid);
    }
}
function get_channel_with_setting_success(t, response)
{
    try
    {
        if (response != null)
        {
            var channel_owner = response.account_guid;
            if (response.account_valid != 1)
            {
                // here we clear check account vaild interval  
                //clearInterval(check_account_vaild_interval);
            }

            var channel_exp_date = convert_utc_channel_expire_date(response.expiration_date);
            if (response.allow_donation == "invaild_account" || response.allow_donation == "false")
            {
                clearInterval(check_video_channel_validation);
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        error_message: "This video belongs to invalid channel",
                    }
                }));
            }
            //if channel is deleted and i have it's link
            else if (response.is_deleted == "true")
            {
                clearInterval(check_video_channel_validation);
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        error_message: "This video belongs to deleted channel",
                    }
                }));
            }
            //if there is no user or user not owner and channel disabled
            else if (response.channel_disabled == "true" && (dv_account_guid == "" || channel_owner != dv_account_guid))
            {
                clearInterval(check_video_channel_validation);
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        error_message: "This video belongs to disabled channel",
                    }
                }));
            }
            else if (check_channel_expiration_date(channel_exp_date) && channel_owner != dv_account_guid)
            {
                clearInterval(check_video_channel_validation);
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        error_message: "This video belongs to expired channel",
                    }
                }));
            }
            // if channel private and there is no user or user not owner 
            else if (response.is_private == "true" && (dv_account_guid == "" || channel_owner != dv_account_guid))
            {
                clearInterval(check_video_channel_validation);
                t.setState(prevState => ({
                    videoData: {
                        ...prevState.videoData,
                        error_message: "This video belongs to private channel",
                    }
                }));


                //clearInterval(check_video_channel_validation);

                //$("#StrobeMediaPlayback").remove();
            }
            else if (first_time_play_video)
            {
                load_video_info(t);
                first_time_play_video = false;
            }
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "get_channel_with_setting_success",
            ex, "account_guid=" + dv_account_guid + "&channel_guid=" + channel_guid);
    }
}

function get_channel_with_setting_error(ex)
{
    globalUtils.send_error_fun("playerUiJs_index.js",
        "get_channel_with_setting_error",
        ex, "account_guid=" + dv_account_guid + "&channel_guid=" + channel_guid + "&browser=" + browser + "&visitor_ip=" + visitor_ip
        + "api_link=" + localStorage.getItem("api_url") + "get_channel_with_settings_by_channel_guid");
}
function convert_utc_channel_expire_date(channel_expire_utc_date)
{
    var channel_expire_date = new Array();
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && channel_expire_utc_date.indexOf('T') > -1)
    {
        channel_expire_utc_date = channel_expire_utc_date.replace('T', ' ');
    }
    var new_channel_expire_utc_date = new Date(channel_expire_utc_date);
    if (new_channel_expire_utc_date.getFullYear() != 1990)
    {
        var time_country_zone = -(new_channel_expire_utc_date.getTimezoneOffset() / 60);
        var hours_plus_time_country_zone = (new_channel_expire_utc_date).setHours((new_channel_expire_utc_date).getHours() + time_country_zone);

        channel_expire_date = globalUtils.get_proper_date(new_channel_expire_utc_date);

        //return channel_expire_date;
        var month = channel_expire_date[1] + 1;
        // month
        if (month < 10)
        {
            month = '0' + month
        }

        return (month + "/" + channel_expire_date[0] + "/" + channel_expire_date[2] + " " + channel_expire_date[3] + ":" + channel_expire_date[4])//+ ":" + channel_expire_date[5]);
    }
    else
    {
        return channel_expire_utc_date;
    }
}
function check_channel_expiration_date(channel_expiration_date)
{
    try
    {
        if (channel_expiration_date != undefined && channel_expiration_date != null)
        {
            var now = new Date();
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && channel_expiration_date.indexOf('T') > -1)
            {
                channel_expiration_date = channel_expiration_date.replace('T', ' ');
            }
            var expire_channel_date = new Date(channel_expiration_date);

            if (expire_channel_date.getFullYear() != 1990 && expire_channel_date < now)
            {
                return true;
            }
            else
            {
                return false;
            }
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "check_channel_expiration_date",
            ex, "account_guid=" + dv_account_guid + "&channel_guid=" + channel_guid);
    }
}

export function get_linearbroadcast_current_event_playing(t,ott_account_guid)
{
    var more_error_info = "account_guid=" + dv_account_guid + "&video_guid=" + video_guid + "api_link=" + localStorage.getItem("api_url") + "get_channel_with_settings_by_channel_guid";
    try
    {
        if (localStorage.getItem("api_url"))
        {
            var api_link = localStorage.getItem("api_url") + "get_linearbroadcast_current_event_playing";
            var parameters = {
                account_guid: ott_account_guid,
                error_info: more_error_info
            };
            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                { get_linearbroadcast_current_event_playing_success(t, response); },
                error: get_linearbroadcast_current_event_playing_error
            });
        }
        else
        {

            globalUtils.get_api_url(t);
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerUiJs_index.js",
            "get_channel_with_setting",
            ex, "account_guid=" + dv_account_guid + "&channel_guid=" + channel_guid);
    }
}
function get_linearbroadcast_current_event_playing_success(t, response)
{
    if (response && response.vod_title)
    {
        t.setState(prevState => ({
            videoData: {
                ...prevState.videoData,

                video_title: response.vod_title,
            }
        }), () =>
        {
            current_playing_interval = setInterval(function ()
            {
                get_linearbroadcast_current_event_playing(t, globalUtils.getParameterByName("ottacg", t));
            }, 300000);
        });
    }
}
function get_linearbroadcast_current_event_playing_error(ex)
{

}